/** L2 Follow-up Table expand/collapse preference, keyed by logged-in email. */
const storageKey = () => {
  const email = typeof localStorage !== "undefined" ? localStorage.getItem("email") || "" : "";
  return `followupTableExpanded_${email}`;
};

export function readFollowupTableExpanded() {
  if (typeof localStorage === "undefined") return false;
  const stored = localStorage.getItem(storageKey());
  if (stored === null) return false;
  return stored === "true";
}

export function writeFollowupTableExpanded(expanded) {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(storageKey(), expanded ? "true" : "false");
}
